module.exports = __webpack_public_path__ + "static/media/boy-20.06463b1a.svg";